// Pure canvas grid math, mirroring the legacy main.js constants and helpers
// exactly (getPixelSize / getSnapCoords). Kept in app-web rather than
// @bento/shared because it's specific to the web canvas layout, not the
// data/domain contracts.

// 1 grid block = 100px, gap = 10px, so each step (block + gap) = 110px.
export const GRID_SIZE = 100;
export const GRID_GAP = 10;
export const STEP = GRID_SIZE + GRID_GAP; // 110

// A module's pixel left/top is (grid index * STEP); invert by rounding to the
// nearest grid line — same as the legacy getSnapCoords.
export function pxToGridPos(px: number): number {
  return Math.round(px / STEP);
}

export function gridPosToPx(pos: number): number {
  return pos * STEP;
}

// N blocks span N*100 + (N-1)*10 px (gaps sit between blocks only) — identical
// to the legacy getPixelSize.
export function gridSizeToPx(units: number): number {
  return units * GRID_SIZE + (units - 1) * GRID_GAP;
}
